import { useKeycloak } from "@react-keycloak/web";
import { Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (keycloak && keycloak.authenticated) {
  //     navigate('/welcome');
  //   }
  // }, [keycloak, navigate]);

  if (!keycloak.authenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
